import React from "react"
import { GroupBase } from "react-select"
import AsyncSelect from "react-select/async"
import { SelectContainer } from ".."
import { setDefaults } from "../../helpers"
import { AsyncSearchableSelectProps } from "../../types"

const AsyncSearchableSelect = <
  OptionType,
  IsMulti extends boolean,
  Group extends GroupBase<OptionType>
>(
  props: AsyncSearchableSelectProps<OptionType, IsMulti, Group>
) => {
  const newProps = setDefaults(props)

  return (
    <SelectContainer
      id={newProps.id}
      name={newProps.name}
      hint={newProps.hint}
      error={newProps.error}
      noValidation={newProps.noValidation}
    >
      <AsyncSelect {...newProps} />
      {newProps.children}
    </SelectContainer>
  )
}

export default AsyncSearchableSelect
